<template>
<div class="EmployeeData">    
    <div v-if="employeeData.permitirModificacionDatos == 1" class="row">
        <div class="col align-right mb-2">
            <a href="#" class="btn-dashed waves-effect" @click.prevent="edit()">
                <i class="ms-Icon ms-Icon--Add"></i> {{ $t('notificarModificacion') }}
            </a>
        </div>
    </div>
    <div class="card mb-3">
        <div class="body">
            <div class="row clearfix">
                <div class="col-md-4 col-xs-12">
                    <div class="user">
                        <h5 class="mt-3 mb-1">{{employeeData.nombre}}</h5>
                        <h3>{{employeeData.primerApellido}}&nbsp;{{employeeData.segundoApellido}}</h3>
                    </div>
                    <div class="mt-2">                           
                        <img class="avatar" id="employeePicture" :src="urlAvatar" alt="Imagen perfil">
                    </div>    
                </div>

                <div class="col-md-4 col-xs-12">
                    <small class="text-muted">
                        <span>{{ $t('NIF') }}</span></small>
                    <p>{{employeeData.nif}}</p>

                    <small class="text-muted">
                        <span>{{ $t('NASS') }}</span></small>
                    <p>{{employeeData.numAfiliacSS}}</p>

                    <small class="text-muted">
                        <span>{{ $t('address') }}</span></small>
                    <p>
                        {{employeeData.sigDomicilio}} {{employeeData.domicilio}} {{ employeeData.casa }}, 
                        <span v-if="employeeData.portal">{{ $t('portal') }} {{ employeeData.portal }},</span>
                        <span v-if="employeeData.bloque">{{ $t('bloque') }} {{ employeeData.bloque }}, </span>
                        <span v-if="employeeData.escalera">{{ $t('escalera') }} {{ employeeData.escalera }}, </span>
                        <span v-if="employeeData.piso">{{ $t('piso') }} {{ employeeData.piso }}</span>
                    </p>

                    <small class="text-muted">
                        <span>{{ $t('cp') }}</span></small>
                    <p>{{employeeData.codPostal}}</p>

                    <small class="text-muted">
                        <span>{{ $t('city') }}</span></small>
                    <p>{{employeeData.nombrePoblacion}}</p>

                    <small class="text-muted">
                        <span>{{ $t('province') }}</span></small>
                    <p>{{employeeData.nombreProvincia}}</p>

                    <small class="text-muted">
                        <span>{{ $t('country') }}</span></small>
                    <p>{{employeeData.nombrePais}}</p>

                    <small class="text-muted">
                        <span>{{ $t('email') }}:</span></small>
                    <p>{{employeeData.email}}</p>
                </div>

                <div class="col-md-4 col-xs-12">
                    <small class="text-muted"><span>{{ $t('birthDate') }}</span></small>
                    <p>{{employeeData.fecNacimiento}}</p>

                    <small class="text-muted">
                        <span>{{ $t('civilStatus') }}</span></small>
                    <p>{{estadosCiviles[employeeData.estadoCivil]}}</p>

                    <small class="text-muted">
                        <span>{{ $t('phone') }}</span></small>
                    <p>{{employeeData.telefono}}</p>

                    <small class="text-muted">
                        {{ $t('mobile') }}</small>
                    <p>{{employeeData.telefonoMovil}}</p>  

                    <div v-if="employeeData.gradoDiscapacidad != 0"></div>
                    <small class="text-muted">
                        {{ $t('porGradoDiscapacidad') }}</small>
                    <p>{{employeeData.gradoDiscapacidad}}</p>  
                </div>
            </div>      
        </div>
    </div> 
</div>

</template>

<style scoped>
#employeePicture {
    max-width: 300px!important;
}
</style>

<script>
import { employeeService } from '@/api/employee';

export default {
    name: 'EmployeeData',
    components: {
    },
    data(){
        return {
            urlAvatar: '',
            employeeData: [],
            employeeDataDiario: [],
            estadosCiviles: [],         
        }
    },
    async mounted () {
        
        this.employeeData = await employeeService.getDataEmployee();        
        this.urlAvatar = `${this.$Params.urlBase}img/avatar-${this.employeeData.userType}.jpg`;
       
        this.estadosCiviles = await employeeService.getEstadosCiviles();
    },
    methods: {
        
        edit() {            
            this.$router.push({
                name: 'employee-edit',
                params: {
                    estadosCivilesProp: this.estadosCiviles
                }
            });
        }
    }
}
</script>